<template>
  <div class="item"
       v-if="read"
       :style="`background: ${read.color ? read.color : '#fff'};
        color: ${read.titleColor ? read.titleColor : '#000'};`">
    <div
        class="wrapper"
        @click="router.push(`/reads/${read.slug}`)">
      <div class="info">
        <div class="title">{{ read.title }}</div>
        <div class="tags">
          {{Array.isArray(read.tag) ? read.tag[0].title || '' : read.tag.title}} {{read.author ? 'by' : ''}} {{ read.author || '' }}
        </div>
      </div>
      <img :src="previewImage" alt="Item Image" class="item-image">

    </div>
    <div v-if="user && active" class="actions">
      <RoundedIcon
          ref="roundedIcon"
          :class="[isReadInAnyGallery(read) ? 'selected' : '', 'h-24']"
          src="/icons/plus_black.png"
          @click="addToHighlight(user.allRemarks, read)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useUserStore} from "~/composables/useUserStore";

const {user} = useUserStore();
const { galleries, patchGallery, createGallery, deleteGallery, toggleEditBoardPopup, toggleDeleteBoardPopup } = useWorkStore();

import {defineProps, defineEmits, onMounted, ref} from 'vue';
import {useRouter} from "vue-router";
import axios from "axios";
import Popover from "~/components/Popover.vue";
import RoundedIcon from "~/components/RoundedIcon.vue";
import BoardItem from "~/components/works/BoardItem.vue";
import {useWorkStore} from "~/composables/useWorkStore";
import type {Gallery} from "~/types/types";
const router = useRouter();
const props = defineProps({
  read: {
    type: Object,
    required: true
  },
  active: {
    type: Boolean,
    default: true
  }
});
const isPopoverOpen = ref(false);
const isPopoverDisabled = ref(false);
const isVimeo = ref(false);
const vimeoEmbedUrl = ref('');

const newBoard = async () => {
  toggleEditBoardPopup(null);
};
const videoData = ref<any>(null);
const previewImage = ref(props.read.coverImage);
const emit = defineEmits(['updated']);

const addToHighlight = async (gallery:any, read:any) => {
  const galleryReadsIds = gallery.reads.map((r: any) => r ? r.read._id || r : '');
  console.log('gallery', galleryReadsIds);
  if (galleryReadsIds.includes(read._id)) {
    const indexOf = galleryReadsIds.indexOf(read._id);
    gallery.reads.splice(indexOf, 1);
  } else {
    const readItem = {
      read: read._id
    }
    gallery.reads.push(readItem);
  }
  await saveGallery(gallery);
}

const delete_gallery = async (gallery:any) => {
  await deleteGallery(gallery._id);
  console.log('deletedGal');
  emit('updated');
}
const saveGallery = async (gallery: any) => {
  const save = await patchGallery(gallery, gallery._id);
  console.log('saved', save);
  emit('updated');
};
const updatePopoverState = (newState: any) => {
  isPopoverOpen.value = newState;
};

const isReadInGallery = (gallery:any, read:any) => {
  return gallery.reads.some((galRead:any) => {
    return galRead.read._id === read._id
  });
}

const isReadInAnyGallery = (read: any) => {
  const gals = galleries.value;
  const allRemarks = user.value.allRemarks;
  // Check if the work exists in the allRemarks gallery
  const isInAllRemarks = isReadInGallery(allRemarks, read);

  if (isInAllRemarks) {
    return true;
  }

  // Check if the work exists in any of the other galleries
  return gals.some((gallery: any) => isReadInGallery(gallery, read));
}
const getVimeoVideoId = (url: any) => {
  const regex = /vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)(?:$|\/|\?)/;
  const match = regex.exec(url);
  return match ? match[1] : null;
};

const fetchVideo = async (videoUrl: string) => {
  try {
    const videoId = getVimeoVideoId(videoUrl);
    if (!videoId) {
      return;
    }

    const response = await axios.get(`https://api.vimeo.com/videos/${videoId}`, {
      headers: {
        Authorization: `Bearer 2882f8d876e951dfb0357c88629dcf78` // Replace with your Vimeo access token
      }
    });

    videoData.value = response.data;
    previewImage.value = videoData.value.pictures.sizes[0].link;
  } catch (error) {
    console.error('Vimeo API error:', error);
  }
};
function getTextColorForBackground(color: string) {
  // Convert hex color to RGB
  const hexToRgb = (hex: string) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex.split('').map(hex => hex + hex).join('');
    }
    const num = parseInt(hex, 16);
    return [num >> 16, (num >> 8) & 255, num & 255];
  };

  // Calculate luminance
  const luminance = (r: any, g: any, b: any) => {
    const a = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  };

  const [r, g, b] = hexToRgb(color);
  const luminanceValue = luminance(r, g, b);

  // Choose text color based on luminance
  console.log('luminanceValue', luminanceValue);
  return luminanceValue > 0.179 ? 'black' : 'white';
}

onMounted(async () => {
  previewImage.value = props.read.coverImage;
});
</script>

<style scoped>
.item {
  display: grid;
  grid-template-rows: 1fr auto;
  overflow: visible;
  position: relative;
  width: 100%;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
}
.item > div {
  position: relative;
}
.archive {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  border: 1px solid #dadada;
}
.archive .label {
  font-size: 32px;
  padding: 20px 37px;
  color: black;
}

.item-image {
  width: 100%;
  height: auto;
  aspect-ratio: 4/5;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

.info {
  color: inherit;
  width: 100%;
  padding-bottom: 40px;
}

.title {
  margin: 0;
  font-size: 22px;
  line-height: 1;
}
.tags {
  margin: 0;
  font-size: 16px;
}
.actions {
  position: absolute !important;
  top: 18px;
  right: 18px;
  width: 24px;
}
.item {
}
.vimeo-wrapper {
  border-radius: 10px;
  overflow: hidden;
}
.vimeo-wrapper iframe {
  width: 100%;
  height: 100%;
}
</style>
